export default __webpack_public_path__ + "static/media/step_img_5.3de2e558.png";